import getCurrentSelectedTableView from './getSelectedTableView';
import setMailListFocusInfo from '../actions/setMailListFocusInfo';

/**
 * Resets the focus info for the current selected table
 */
export default function resetMailListFocus() {
    setMailListFocusInfo(getCurrentSelectedTableView(), {
        shouldFocusInMailList: false,
        focusedRowId: null,
    });
}
